import { render, staticRenderFns } from "./form-error.vue?vue&type=template&id=4c0eb2b9&"
import script from "./form-error.vue?vue&type=script&lang=ts&"
export * from "./form-error.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports